import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [testTakersOpen, setTestTakersOpen] = useState(false);
  const [testCentersOpen, setTestCentersOpen] = useState(false);
  const [helpCenterOpen, setHelpCenterOpen] = useState(false);
  const [companyOpen, setCompanyOpen] = useState(false);
  
  const testTakersRef = useRef(null);
  const testCentersRef = useRef(null);
  const helpCenterRef = useRef(null);
  const companyRef = useRef(null);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (testTakersRef.current && !testTakersRef.current.contains(event.target)) {
        setTestTakersOpen(false);
      }
      if (testCentersRef.current && !testCentersRef.current.contains(event.target)) {
        setTestCentersOpen(false);
      }
      if (helpCenterRef.current && !helpCenterRef.current.contains(event.target)) {
        setHelpCenterOpen(false);
      }
      if (companyRef.current && !companyRef.current.contains(event.target)) {
        setCompanyOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header 
      className="bg-white text-[#446795] py-[4px] lg:py-[1em] justify-between items-center sticky top-0 z-20"
      style={{ 
        boxShadow: '0px 12px 22px 0px rgba(24, 50, 84, 0.05)',
        fontFamily: 'DM Sans'
      }}
    >
      <div className="mx-auto max-w-screen-2xl px-2 flex flex-col items-stretch lg:flex-row lg:px-4">
        <div className="flex flex-row flex-auto pb-2 lg:pb-0">
          <Link to="https://credentia.com/" className="flex-grow">
            <img 
              height="55" 
              className="min-h-[35px] max-h-[55px] max-w-[200px] lg:max-w-none" 
              src={`${process.env.PUBLIC_URL}/logo.svg`}
              alt="Credentia Logo"
            />
          </Link>
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="pl-4 lg:hidden font-extrabold text-2xl"
            aria-label="Toggle menu"
            style={{ color: '#446795' }}
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>

        <nav 
          className={`font-bold gap-3 xl:gap-7 text-center flex flex-col flex-grow items-center justify-center lg:flex-row ${
            mobileMenuOpen ? 'flex' : 'hidden'
          } lg:!flex`}
          aria-labelledby="primary-navigation"
        >
          <h2 id="primary-navigation" className="sr-only">Primary Navigation</h2>

          {/* Test Takers Dropdown */}
          <div 
            ref={testTakersRef}
            className="flex flex-col lg:flex-none lg:block lg:relative"
          >
            <button 
              onClick={() => setTestTakersOpen(!testTakersOpen)}
              className={`hover:before:w-full hover:before:relative hover:before:top-[1.5rem] hover:before:block p-2 font-bold lg:text-[17px] xl:text-[19px] tracking-[-0.05em] after:rotate-45 after:transform after:transition-all after:contents after:h-[16px] after:w-[16px] after:bg-salmon after:absolute after:right-1 ${
                testTakersOpen ? 'after:opacity-100 after:bottom-[-0.6rem] before:hidden' : 'after:opacity-0 after:-bottom-4'
              }`}
            >
              Test Takers{' '}
              <span 
                className={`text-xs lg:text-[1.25rem] transform transition-all inline-block translate-y-[2px] ${
                  testTakersOpen ? 'rotate-0' : '-rotate-90'
                }`}
                style={{ color: '#1C75BC' }}
              >
                {testTakersOpen ? '−' : '+'}
              </span>
            </button>
            {testTakersOpen && (
              <nav 
                className="grid gap-x-4 w-max place-content-end border-salmon bg-white/90 backdrop-blur-xl border-gray-100 border-[1px] p-4 lg:absolute lg:rounded-lg lg:shadow-lg lg:z-40 lg:text-left overflow-y-auto"
              >
                <Link 
                  to="https://credentia.com/test-takers"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setTestTakersOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  Test Takers
                </Link>
                <Link 
                  to="https://cna365.examroom.ai/gis/public-events"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setTestTakersOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  Test Center Availability
                </Link>
              </nav>
            )}
          </div>

          {/* Test Centers Dropdown */}
          <div 
            ref={testCentersRef}
            className="flex flex-col lg:flex-none lg:block lg:relative"
          >
            <Link 
              to="https://credentia.com/test-centers" 
              className="hidden p-2 lg:text-base xl:text-lg lg:text-md hover:before:w-full hover:before:relative hover:before:top-[1.5rem] hover:before:block"
            >
              Find CNA Test Centers near me
            </Link>
            <button 
              onClick={() => setTestCentersOpen(!testCentersOpen)}
              className={`hover:before:w-full hover:before:relative hover:before:top-[1.5rem] hover:before:block p-2 font-bold lg:text-[17px] xl:text-[19px] tracking-[-0.05em] after:rotate-45 after:transform after:transition-all after:contents after:h-[16px] after:w-[16px] after:bg-salmon after:absolute after:right-1 ${
                testCentersOpen ? 'after:opacity-100 after:bottom-[-0.6rem] before:hidden' : 'after:opacity-0 after:-bottom-4'
              }`}
            >
              Test Centers{' '}
              <span 
                className={`text-xs lg:text-[1.25rem] transform transition-all inline-block translate-y-[2px] ${
                  testCentersOpen ? 'rotate-0' : '-rotate-90'
                }`}
                style={{ color: '#1C75BC' }}
              >
                {testCentersOpen ? '−' : '+'}
              </span>
            </button>
            {testCentersOpen && (
              <nav 
                className="grid gap-x-4 w-max place-content-end border-salmon bg-white/90 backdrop-blur-xl border-gray-100 border-[1px] p-4 lg:absolute lg:rounded-lg lg:shadow-lg lg:z-40 lg:text-left overflow-y-auto"
              >
                <Link 
                  to="https://credentia.com/test-centers"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setTestCentersOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  Test Centers
                </Link>
                <Link 
                  to="https://credentia.com/test-centers/rts"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setTestCentersOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  Becoming a Regional Test Site
                </Link>
                <Link 
                  to="https://credentia.com/test-centers/inf"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setTestCentersOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  Becoming an In-Facility Test Center
                </Link>
                <Link 
                  to="#"
                  id="TClogin"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md link-button text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setTestCentersOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  Test Center Login
                </Link>
              </nav>
            )}
          </div>

          <Link 
            to="https://credentia.com/test-proctors" 
            className="p-2 lg:text-[17px] xl:text-[19px] tracking-[-0.05em] hover:before:w-full hover:before:relative hover:before:top-[1.5rem] hover:before:block"
            onClick={() => setMobileMenuOpen(false)}
          >
            Nurse Aide Evaluator
          </Link>

          {/* Help Center Dropdown */}
          <div 
            ref={helpCenterRef}
            className="flex flex-col lg:flex-none lg:block lg:relative"
          >
            <Link 
              to=""
              className="hidden p-2 lg:text-base xl:text-lg lg:text-md hover:before:w-full hover:before:relative hover:before:top-[1.5rem] hover:before:block"
            >
              CNA Exam | NNAAP | MACE | Nurse Aide Evaluator
            </Link>
            <button 
              onClick={() => setHelpCenterOpen(!helpCenterOpen)}
              className={`hover:before:w-full hover:before:relative hover:before:top-[1.5rem] hover:before:block p-2 font-bold lg:text-[17px] xl:text-[19px] tracking-[-0.05em] after:rotate-45 after:transform after:transition-all after:contents after:h-[16px] after:w-[16px] after:bg-blue after:absolute after:right-1 ${
                helpCenterOpen ? 'after:opacity-100 after:bottom-[-0.6rem] before:hidden' : 'after:opacity-0 after:-bottom-4'
              }`}
            >
              Help Center{' '}
              <span 
                className={`text-xs lg:text-[1.25rem] transform transition-all inline-block translate-y-[2px] ${
                  helpCenterOpen ? 'rotate-0' : '-rotate-90'
                }`}
                style={{ color: '#1C75BC' }}
              >
                {helpCenterOpen ? '−' : '+'}
              </span>
            </button>
            {helpCenterOpen && (
              <nav 
                className="grid gap-x-4 w-max place-content-end border-blue bg-white/90 backdrop-blur-xl border-gray-100 border-[1px] p-4 lg:absolute lg:rounded-lg lg:shadow-lg lg:z-40 lg:text-left overflow-y-auto"
              >
                <Link 
                  to="https://help.credentia.com"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setHelpCenterOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  Self Help Guides
                </Link>
                <Link 
                  to="https://credentia.com/system-check"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setHelpCenterOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  Run System Test
                </Link>
                <Link 
                  to="https://credentia.com/about-us/nurse-aide-resource-center"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setHelpCenterOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  Nurse Aide Guide
                </Link>
                <Link 
                  to="https://credentia.com/online-exams"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setHelpCenterOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  Online Exams Guide
                </Link>
                <Link 
                  to="https://credentia.com/about-us/contact-information"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setHelpCenterOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  State Contacts
                </Link>
                <Link 
                  to="https://status.credentia.com/"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md link-button text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setHelpCenterOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  System Status
                </Link>
              </nav>
            )}
          </div>

          {/* Company Dropdown */}
          <div 
            ref={companyRef}
            className="flex flex-col lg:flex-none lg:block lg:relative"
          >
            <Link 
              to="https://credentia.com/about-us"
              className="hidden p-2 lg:text-base xl:text-lg lg:text-md hover:before:w-full hover:before:relative hover:before:top-[1.5rem] hover:before:block"
            >
              About Credentia- Empowering Healthcare Excellence
            </Link>
            <button 
              onClick={() => setCompanyOpen(!companyOpen)}
              className={`hover:before:w-full hover:before:relative hover:before:top-[1.5rem] hover:before:block p-2 font-bold lg:text-[17px] xl:text-[19px] tracking-[-0.05em] after:rotate-45 after:transform after:transition-all after:contents after:h-[16px] after:w-[16px] after:bg-[#013366] after:absolute after:right-1 ${
                companyOpen ? 'after:opacity-100 after:bottom-[-0.6rem] before:hidden' : 'after:opacity-0 after:-bottom-4'
              }`}
            >
              Company{' '}
              <span 
                className={`text-xs lg:text-[1.25rem] transform transition-all inline-block translate-y-[2px] ${
                  companyOpen ? 'rotate-0' : '-rotate-90'
                }`}
                style={{ color: '#1C75BC' }}
              >
                {companyOpen ? '−' : '+'}
              </span>
            </button>
            {companyOpen && (
              <nav 
                className="grid gap-x-4 w-max place-content-end border-blue bg-white/90 backdrop-blur-xl border-gray-100 border-[1px] p-4 lg:absolute lg:rounded-lg lg:shadow-lg lg:z-40 lg:text-left overflow-y-auto"
              >
                <Link 
                  to="https://credentia.com/about-us"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setCompanyOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  About Us
                </Link>
                <Link 
                  to="https://credentia.com/about-us/mission-vision-and-values"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setCompanyOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  Mission, Vision, & Values
                </Link>
                <Link 
                  to="https://career.credentia.com/"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setCompanyOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  Careers
                </Link>
                <Link 
                  to="https://credentia.com/conference"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setCompanyOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  Events and Calendar
                </Link>
                <Link 
                  to="https://credentia.com/committees"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setCompanyOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  Committees
                </Link>
                <Link 
                  to="https://credentia.com/contact-credentia"
                  className="hover:bg-gray-200 lg:text-base xl:text-lg lg:text-md py-2 px-2 rounded-md text-gray-600 hover:text-[#013366]"
                  onClick={() => {
                    setCompanyOpen(false);
                    setMobileMenuOpen(false);
                  }}
                >
                  Contact Credentia
                </Link>
              </nav>
            )}
          </div>

          {/* Mobile Action Buttons */}
          <Link 
            to="https://credentia.com/practice-exams" 
            className="lg:hidden p-2 lg:text-[17px] xl:text-[19px] tracking-[-0.05em] hover:before:w-full hover:before:relative hover:before:top-[1.5rem] hover:before:block"
            onClick={() => setMobileMenuOpen(false)}
          >
            Practice Exams
          </Link>
          <Link 
            to="https://cna365.examroom.ai/login/"
            className="lg:hidden p-2 lg:text-[17px] xl:text-[19px] tracking-[-0.05em] hover:before:w-full hover:before:relative hover:before:top-[1.5rem] hover:before:block"
            onClick={() => setMobileMenuOpen(false)}
          >
            Login
          </Link>
        </nav>

        {/* Secondary Navigation - Desktop Action Buttons */}
        <h2 id="secondary-navigation" className="sr-only">Secondary Navigation</h2>
        <div className="flex space-x-2">
          <Link 
            to="https://credentia.com/practice-exams" 
            className="hidden lg:flex lg:text-base xl:text-lg lg:text-md flex-col justify-center items-center first:text-blue first:bg-white first:border-2 first:border-blue-600 text-white bg-credentia_blue first:hover:bg-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 rounded-full lg:text-base xl:text-lg lg:text-md px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            style={{ 
              color: '#1C75BC', 
              backgroundColor: 'white', 
              border: '2px solid #1C75BC',
              fontFamily: 'DM Sans, sans-serif'
            }}
          >
            <span className="relative">Practice Exams</span>
          </Link>
          <Link 
            to="https://cna365.examroom.ai/login/"
            className="hidden lg:flex lg:text-base xl:text-lg lg:text-md flex-col justify-center items-center text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 rounded-full px-5 py-2.5 text-center"
            style={{ 
              backgroundColor: '#1C75BC',
              fontFamily: 'DM Sans, sans-serif'
            }}
          >
            <span className="relative">Login</span>
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
